import React from 'react';
type Props = {
  hasClickedApply: boolean;
  onClickApply: () => void;
};
export function Navigation({
  hasClickedApply,
  onClickApply
}: Props) {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200" data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="flex items-center justify-between h-16" data-id="element-103">
          <div className="flex items-center" data-id="element-104">
            <img src="https://cdn.magicpatterns.com/uploads/2Vc1SybtX5ntsou5rRY33H/NTY-Logo.png" alt="NTY Windows" className="h-10 w-auto" data-id="element-105" />
          </div>

          <div className="flex items-center space-x-4" data-id="element-106">
            <div className="hidden sm:block px-3 py-1 bg-gray-100 rounded-full text-sm font-medium text-gray-700" data-id="element-107">
              Missoula, MT
            </div>
            <button onClick={onClickApply} className="px-4 sm:px-6 py-2 bg-maroon text-white text-sm sm:text-base font-semibold rounded hover:bg-opacity-90 transition-colors whitespace-nowrap" data-id="element-108">
              {hasClickedApply ? 'Finish video to see apply link' : 'Apply Now'}
            </button>
          </div>
        </div>
      </div>
    </nav>;
}